
import React, { useState, useEffect, useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useTheme } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import ProviderAPI from 'config/api/ProviderAPI'
import { onError } from 'config/lib/errorLib'
import Loader from 'components/general/Loader'
import PrimaryPersonCard from 'components/provider/PrimaryPersonCard'
import CompanyDetailsCard from 'components/provider/CompanyDetailsCard'
import AboutCompanyCard from 'components/provider/AboutCompanyCard'
import EditRecommendationCard from 'components/provider/EditRecommendationCard'
import TechnologyCard from 'components/provider/TechnologyCard'
import ProductCard from 'components/provider/ProductCard'
import CaseStudiesCard from 'components/provider/CaseStudiesCard'
import CountiesCard from 'components/provider/CountiesCard'
import HelperCard from 'components/provider/HelperCard'
import { productCategoryMap } from 'config/constants/Constants'


function Profile() {
    const api = new ProviderAPI()

    const [company, setCompany] = useState([])
    const [brands, setBrands] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        getCompany()
    }, [])

    async function getCompany() {
        try {
            const company = await api.getCompany()
            console.log('company: ', company)
            const brands = await api.getBrands()

            setCompany(company)
            setBrands(brands.sort((a, b) => a.brandName.localeCompare(b.brandName)))
            setLoading(false)
        } catch(e) {
            onError(e)
        }
    }

    // Centralized update function for deep updates
    function updateCompanyField(path, value) {
        setCompany(prev => {
            const updated = { ...prev }
            const keys = path.split('.')
            let obj = updated
            for (let i = 0; i < keys.length - 1; i++) {
                obj[keys[i]] = { ...obj[keys[i]] }
                obj = obj[keys[i]]
            }
            obj[keys[keys.length - 1]] = value
            return updated
        })
    }

    // Products this provider offers (admin-controlled via productsAvailable).
    const productsAvailable = company.productsAvailable || {}
    const enabledProducts = Object.keys(productsAvailable).filter(p => productsAvailable[p])
    const isSolar = enabledProducts.includes('Solar')
    // Non-solar products that have a dedicated technology/profile configuration.
    const productCards = enabledProducts.filter(p => p !== 'Solar' && productCategoryMap[p])

    return (
        <Container
            maxWidth={false}
            component={Box}
            marginTop='2rem'
        >
            {!loading ? (
                <Grid container spacing={3}>
                    <Grid item xs={12} md={8}>
                        <PrimaryPersonCard
                            companyId={company.companyId}
                            details={company.primaryPerson}
                            companyDetails={company}
                            updateField={updateCompanyField}
                            updateCompany={setCompany}
                            profile
                        />
                        {enabledProducts.length > 0 && (
                            <CountiesCard
                                products={enabledProducts}
                                companyId={company.companyId}
                                companyDetails={company}
                                updateField={updateCompanyField}
                                updateCompany={setCompany}
                                profile
                            />
                        )}
                        <CompanyDetailsCard
                            companyId={company.companyId}
                            name={company.name}
                            url={company.url}
                            details={company.profileDetails}
                            isSolar={isSolar}
                            enabledProducts={enabledProducts}
                            updateField={updateCompanyField}
                            updateCompany={setCompany}
                            profile
                        />
                        {enabledProducts.length > 0 && (
                            <EditRecommendationCard
                                companyId={company.companyId}
                                details={company.profileDetails || {}}
                                isSolar={isSolar}
                                enabledProducts={enabledProducts}
                                updateField={updateCompanyField}
                                updateCompany={setCompany}
                                profile
                            />
                        )}
                        <AboutCompanyCard
                            companyId={company.companyId}
                            name={company.name}
                            url={company.url}
                            details={company.profileDetailsExtended}
                            updateField={updateCompanyField}
                            updateCompany={setCompany}
                            profile
                        />
                        {isSolar && (
                            <TechnologyCard
                                companyId={company.companyId}
                                details={company.technology}
                                companyDetails={company}
                                brands={brands}
                                updateField={updateCompanyField}
                                updateCompany={setCompany}
                                profile
                            />
                        )}
                        {productCards.map(product => (
                            <ProductCard
                                key={product}
                                product={product}
                                companyId={company.companyId}
                                companyDetails={company}
                                brands={brands}
                                updateField={updateCompanyField}
                                updateCompany={setCompany}
                                profile
                            />
                        ))}
                        <CaseStudiesCard
                            company={company}
                            newProjectDraft={company.newProjectDraft || {}}
                            updateField={updateCompanyField}
                            updateCompany={setCompany}
                            profile
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        {company && (
                            <div style={{ position: 'sticky', top: '1rem' }}>
                                <HelperCard stage='profileOptional' />
                            </div>
                        )}
                    </Grid>
                </Grid>
            ) : (
                <Grid container justifyContent='flex-start'>
                    <Grid item xs={12}>
                        <Box display='flex' justifyContent='center' alignItems='center' style={{height: '20vh'}}>
                            <Loader />
                        </Box>
                    </Grid>
                </Grid>
            )}
        </Container>
    );
}

export default Profile